(() => {
  function showPrice(target, current, comparison) {
    if (!comparison) { target.textContent = current; return; }
    const reference = document.createElement('span'); reference.className = 'oh-price-comparison';
    const referenceLabel = document.createElement('span'); referenceLabel.className = 'visually-hidden'; referenceLabel.textContent = 'Reference price ';
    const crossed = document.createElement('s'); crossed.textContent = comparison; reference.append(referenceLabel, crossed);
    const amount = document.createElement('span'); amount.className = 'oh-price-current oh-price-current--sale';
    const currentLabel = document.createElement('span'); currentLabel.className = 'visually-hidden'; currentLabel.textContent = 'Current price ';
    amount.append(currentLabel, document.createTextNode(current));
    const badge = document.createElement('span'); badge.className = 'oh-price-sale-label'; badge.textContent = 'Sale';
    const offer = document.createElement('span'); offer.className = 'oh-price-offer'; offer.append(amount, badge);
    target.replaceChildren(reference, document.createTextNode(' '), offer);
  }
  function unknownCount() {
    const icon=document.getElementById('cart-icon-bubble');
    const badge=icon?.querySelector('.oh-cart-count');if(badge){badge.hidden=true;badge.style.display='none';}
    const label=icon?.querySelector('.visually-hidden');if(label)label.textContent='Cart';
  }
  function sizeGuides(scope) {
    scope.querySelectorAll('[data-bare-size-guide]').forEach(guide => {
      if (guide.dataset.sizeGuideReady) return;
      guide.dataset.sizeGuideReady = 'true';
      const units = guide.querySelector('[data-size-units]');
      if (!units) return;
      const showUnits = () => guide.querySelectorAll('[data-size-table]').forEach(panel => {
        panel.hidden = panel.dataset.sizeTable !== units.value;
      });
      units.addEventListener('change', showUnits); showUnits();
      guide.querySelector('[data-size-units-control]').hidden = false;
    });
  }
  function nativeForm(form) {
    if (form.dataset.buyReady) return;
    form.dataset.buyReady = 'true';
    const select = form.querySelector('select[name=id]');
    const button = form.querySelector('button');
    const status = form.querySelector('[data-quick-status]');
    const cartLink=form.querySelector('[data-native-item-link]');
    select.querySelectorAll('[data-build-url]').forEach(option=>{option.disabled=false;});
    const measurements = form.querySelector('[data-custom-measurements]');
    let pending = false;
    function update() {
      const option = select.selectedOptions[0];
      if (measurements) { const custom = option?.dataset.measurementsRequired === 'true'; measurements.hidden = !custom; measurements.disabled = !custom; }
      if (option?.dataset.measurementUrl) {
        button.disabled = pending || option.dataset.available !== 'true';
        button.textContent = pending ? 'Opening…' : button.disabled ? 'Unavailable' : 'Enter measurements';
        return;
      }
      if (option?.dataset.buildUrl) {
        button.disabled = pending; button.textContent = 'Customize'; return;
      }
      button.disabled = pending || !option || option.dataset.available !== 'true';
      button.textContent = pending ? 'Adding…' : button.disabled ? (option?.dataset.holdReason ? 'Unavailable' : 'Sold out') : 'Add to Cart';
      if (option) {
        const card = form.closest('[data-native-card], [data-native-product]');
        const price = card.querySelector('[data-quick-price]');
        if (price) {
          const starting = price.dataset.startingPrice && price.dataset.priceSelected !== 'true';
          showPrice(price, starting ? price.dataset.startingPrice : option.dataset.price, starting ? price.dataset.startingComparePrice : option.dataset.comparePrice);
        }
        const photo = card.querySelector('[data-native-main-image]') || card.querySelector('.oh-shop-card__image > img');
        const photoPending = card.querySelector('[data-native-photo-pending]');
        if (photoPending) { const heldPhoto = option.dataset.holdReason === 'Photo pending'; photoPending.hidden = !heldPhoto; if (photo) photo.hidden = heldPhoto; }
        if (photo && option.dataset.image) { photo.src = option.dataset.image; photo.alt = option.dataset.alt; photo.toggleAttribute('data-supplier-reference',option.dataset.image.includes('oh-xs-reference-')); }
      }
    }
    select.addEventListener('change', () => { const price = form.closest('[data-native-card], [data-native-product]')?.querySelector('[data-quick-price]'); if (price) price.dataset.priceSelected = 'true'; status.textContent = '';cartLink.hidden=true; update(); });
    update();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending || button.disabled || !form.reportValidity()) return;
      const measurementUrl=select.selectedOptions[0]?.dataset.measurementUrl;
      if (measurementUrl) { location.assign(measurementUrl); return; }
      const buildUrl=select.selectedOptions[0]?.dataset.buildUrl;
      if (buildUrl) { location.assign(buildUrl); return; }
      pending = true; update(); status.textContent = ''; status.classList.remove('visually-hidden');
      // Capture the chosen variant before disabling the selector. Send identity and
      // quantity and customer-entered fitting properties; Shopify determines price and stock eligibility.
      const body = new FormData(form);
      const variantId=select.value;cartLink.hidden=true;
      select.disabled = true;
      form.querySelectorAll('[data-native-option]').forEach(control=>{control.disabled=true;});
      body.set('sections', 'cart-icon-bubble');
      body.set('sections_url', location.pathname);
      try {
        const response = await fetch(`${form.action}.js`, { method: 'POST', headers: {Accept: 'application/json'}, body });
        const data = await response.json();
        if (!response.ok || data.status) {
          status.textContent = typeof data.description === 'string' ? data.description : 'This item could not be added. Check availability or choose another option.';
          return;
        }
        // Bundled section rendering is optional. A refresh failure must never
        // trigger a second add, since Shopify may already have accepted the item.
        const fragment = data.sections?.['cart-icon-bubble'];
        let count;
        if (fragment) {
          const parsed = new DOMParser().parseFromString(fragment, 'text/html');
          const content = parsed.querySelector('.shopify-section');
          const text=parsed.querySelector('.oh-cart-count')?.textContent.trim();
          if(text && /^\d+$/.test(text) && Number.isSafeInteger(Number(text)))count=Number(text);
          const icon = document.getElementById('cart-icon-bubble');
          if (content && icon) icon.replaceChildren(...content.childNodes);
        }
        if(count===undefined) unknownCount();
        cartLink.textContent='View in cart';cartLink.removeAttribute('aria-label');cartLink.hidden=false;
        // Read the complete cart to sum this variant across any separate line items.
        // A failed read must never retry an already accepted add.
        try {
          const cartResponse=await fetch(`${form.dataset.cartUrl}.js`,{headers:{Accept:'application/json'},cache:'no-store'});
          if(!cartResponse.ok)throw new Error('Cart unavailable');
          const cart=await cartResponse.json();
          if(!Array.isArray(cart.items))throw new Error('Cart unavailable');
          const quantity=cart.items.filter(item=>String(item.variant_id)===variantId).reduce((sum,item)=>sum+(Number.isSafeInteger(item.quantity)&&item.quantity>0?item.quantity:0),0);
          if(quantity){cartLink.textContent=`(${quantity}) View in cart`;cartLink.setAttribute('aria-label',`${quantity} of this option in cart. View cart`);}
        }catch{/* Keep the link without inventing an item quantity. */}
        status.classList.add('visually-hidden');
        status.textContent = 'Added to your cart.';
        if (!fragment) status.textContent += ' Open your cart to see the updated total.';
      } catch {
        status.classList.remove('visually-hidden');
        unknownCount();
        status.textContent = 'We could not confirm the cart update. Check your cart before trying again.';
      } finally { pending = false; select.disabled = false; form.querySelectorAll('[data-native-option]').forEach(control=>{control.disabled=false;}); update(); }
    });
  }
  window.addEventListener('pageshow',async event=>{
    if(!event.persisted)return;
    const icon=document.getElementById('cart-icon-bubble');
    if(!icon)return;
    try {
      const response=await fetch(`${icon.pathname}.js`,{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error('Cart unavailable');
      const cart=await response.json();
      if(!Number.isSafeInteger(cart.item_count)||!Array.isArray(cart.items))throw new Error('Cart unavailable');
      const badge=icon.querySelector('.oh-cart-count');if(badge){badge.textContent=cart.item_count;badge.hidden=cart.item_count===0;badge.style.display='';}
      const label=icon.querySelector('.visually-hidden');if(label)label.textContent=`Cart, ${cart.item_count} items`;
      document.querySelectorAll('[data-native-add]').forEach(form=>{
        const link=form.querySelector('[data-native-item-link]');if(link.hidden)return;
        const id=form.querySelector('[name=id]').value;
        const count=cart.items.filter(item=>String(item.variant_id)===id).reduce((sum,item)=>sum+item.quantity,0);
        link.hidden=count===0;link.textContent=`(${count}) View in cart`;link.setAttribute('aria-label',`${count} of this option in cart. View cart`);
      });
    }catch{unknownCount();}
  });
  function setup(scope) { sizeGuides(scope); scope.querySelectorAll('[data-native-add]').forEach(nativeForm); }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
